import { render } from "./kubevirt.io.virtualmachine.vue?vue&type=template&id=03db3ff0&scoped=true"
import script from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js"
export * from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js"

import "./kubevirt.io.virtualmachine.vue?vue&type=style&index=0&id=03db3ff0&lang=scss"
import "./kubevirt.io.virtualmachine.vue?vue&type=style&index=1&id=03db3ff0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03db3ff0"]])

export default __exports__